import angular from 'angular'

import excelStyles from './excel.style'
import excelUtils from './excel.utils'
import excelLoader from './excelLoader'

import bulletinFreinageOptions from './wagon/bulletinFreinageOptions.resource'
import compositionOptions from './wagon/compositionOptions.resource'
import dispositionOptions from './wagon/dispositionOptions.resource'
import listOptions from './wagon/listOptions.resource'
import parkOptions from './wagon/parkOptions.resource'
import readinessOptions from './wagon/readinessOptions.resource'
import scrappingOptions from './wagon/scrappingOptions.ressource'
import sortOptions from './wagon/sortOptions.resource'
import unparkOptions from './wagon/unparkOptions.resource'
import wagonExcel from './wagon/wagonExcel.service'

import fixedPartOptions from './invoice/fixedPartOptions.resource'
import invoiceExcel from './invoice/invoiceExcel.service'
import linearOptions from './invoice/linearOptions.resource'
import perDayLimitedOptions from './invoice/perDayLimitedOptions.resource'
import perDayOptions from './invoice/perDayOptions.resource'

import genericOptions from './perso/genericOptions.resource'
import persoExcel from './perso/persoExcel.service'
import simpleOptions from './perso/simpleOptions.resource'

import axletreeOptions from './scrapping/axletreeOptions.resource'
import blEssieuxExcel from './scrapping/blEssieuxExcel.service'
import blWagonsExcel from './scrapping/blWagonsExcel.service'
import destructionExcel from './scrapping/destructionExcel.service'
import scrappingExcel from './scrapping/scrappingExcel.service'

const name = 'excelManager'
angular.module(name, [])
  .factory('excelUtils', excelUtils)
  .factory('excelStyles', excelStyles)
  .factory('excelLoader', excelLoader)

  .factory('bulletinFreinageOptions', bulletinFreinageOptions)
  .factory('compositionOptions', compositionOptions)
  .factory('dispositionOptions', dispositionOptions)
  .factory('listOptions', listOptions)
  .factory('parkOptions', parkOptions)
  .factory('readinessOptions', readinessOptions)
  .factory('scrappingOptions', scrappingOptions)
  .factory('sortOptions', sortOptions)
  .factory('unparkOptions', unparkOptions)
  .factory('wagonExcel', wagonExcel)

  .factory('fixedPartOptions', fixedPartOptions)
  .factory('linearOptions', linearOptions)
  .factory('perDayLimitedOptions', perDayLimitedOptions)
  .factory('perDayOptions', perDayOptions)
  .factory('invoiceExcel', invoiceExcel)

  .factory('genericOptions', genericOptions)
  .factory('simpleOptions', simpleOptions)
  .factory('persoExcel', persoExcel)

  .factory('axletreeOptions', axletreeOptions)
  .factory('scrappingExcel', scrappingExcel)
  .factory('blWagonsExcel', blWagonsExcel)
  .factory('blEssieuxExcel', blEssieuxExcel)
  .factory('destructionExcel', destructionExcel)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/excel.module.js